<template>
  <div class="register">
    <div class="register-cont">
      <RighttopIcon
        @click.native="setRegisterType"
        :type="type"
        :txt="txt"
      ></RighttopIcon>
      <t-message
        v-show="isToastshow"
        theme="error"
        icon
        :duration="2000"
        :content="message"
      />

      <QrcodeRegister v-if="registerType == true" :referUrl="referUrl" />

      <UserRegister v-else :referUrl="referUrl" :codeLogin="codeLogin" />
      
    </div>
    <ProtocolDialog/>
    <!--滑块验证-->
    <slider-verify ref="sliderVerify" @closeDialog="closeDialog"  @success="onSuccess" @again="onAgain" />
  </div>
</template>

<script>
import { zhugeTrack, getQueryString } from "@/utils/utils";
import QrcodeRegister from "@/components/register/qrcodeRegister";
import UserRegister from "@/components/register/userRegister";
import RighttopIcon from "@/components/common/righttopIcon";
import ProtocolDialog from "@/components/common/protocolDialog";
import { mapState,mapMutations } from "vuex";
import sliderVerify from "@/components/common/puzzleVerify";
export default {
  name: "register",
  components: {
    QrcodeRegister,
    UserRegister,
    RighttopIcon,
    ProtocolDialog,
    sliderVerify
  },
  
  data() {
    if(window.location.search.indexOf('match')>-1){
      this.img="/favicon.czb.ico"
      this.title = "用户注册 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛";
    }else{
       this.img="/favicon.ico"
       this.title='用户注册 - 博学谷·黑马程序员线上品牌'
    }
   
   
    this.keywords =
      "大学生计算机比赛,计算机竞赛,容易获奖的大学生比赛,大学含金量高的竞赛,acm竞赛";
    this.discription =
      "传智杯大赛以“协万千名校育人，助天下英才圆梦”为宗旨,积极挖掘高校优秀的IT人才,为企业和社会输送更多IT高级技术型精英,全力推动互联网产业的发展。";
    return {
      type: 2,
      txt: "注册", //切换手机与微信需要的参数
      show: true,
      codeLogin: false,
      registerType: true,
      referUrl: "", // 登录后跳转的页面 （url携带）
      toastshow: false,
    };
  },
  computed: {
    ...mapState(["isToastshow", "message","isShowSliderVerify"]),
  },
  created(){
    if(window.location.search.indexOf('match')>-1){
      this.registerType=false
    }
  },
  mounted() {
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    // 是否是回车课堂登录页
    this.codeLogin = getQueryString("codeLogin");
    // 更换不同主题色
    zhugeTrack("进入_注册页",{
      终端:"Web"
    });
   
  },
  methods: {
    //切换微信注册or登录注册
    setRegisterType() {
      this.registerType = !this.registerType;
      if (!this.registerType) {
        this.type = 1;
        this.txt = "注册";
      } else {
        this.type = 2;
        this.txt = "注册";
      }
    },
    onSuccess(){},
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试")
    },
    closeDialog() {},
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: "keyWords",
          content: "新用户,注册入口,注册,网址,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷官网注册入口，学员可以注册学习账号，选择自己喜欢的IT课程或视频教程，在线学习学习Java、Python、云计算大数据、前端开发、UI设计、人工智能、软件测试与移动开发、PHP、电商运营等视频课程。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: this.img }]
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
  .logo-link {
    margin: 60px 0 0 40px !important;
  }
  .register-cont {
    right: 120px !important;
  }
}
@media screen and (min-width: 1920px) {
  .logo-link {
    margin: 40px 0 0 60px !important;
  }
  .register-cont {
    right: 440px !important;
  }
}
@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .logo-link {
    margin: 40px 0 0 60px !important;
  }
  .register-cont {
    right: 200px !important;
  }
}
.register {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }
  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;
    width: max-content;
    height: 48px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }
  .toast {
    z-index: 999;
    position: absolute;
    top: 40%;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 26px;
    padding: 30px 71px;
    text-align: center;
    white-space: nowrap;
  }

  .register-cont {
    width: 464px;
    height: 520px;
    background: #ffffff;

    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;
  }

  ::v-deep .user-register {
    p {
      span {
        color: #165dff !important;
        &:hover {
          color: #4080ff !important;
        }
      }
    }
    .get-code {
      color: #4e5969 !important;
      &:hover {
        color: #4080ff !important;
      }
    }
  }

  ::v-deep .register-from {
    margin-top: 40px;
    .el-form-item {
      margin-bottom: 24px;
    }
    .el-input__inner {
      width: 368px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      line-height: 40px;

      padding-left: 16px;
      box-sizing: border-box;
      border: 1px solid #e5e6eb;
      &:focus {
        border: 1px solid #165dff;
      }
    }
    .is-error {
      .el-input__inner {
        border: 1px solid #f53f3f;
      }
      .el-form-item__error {
        padding-top: 0px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f53f3f;
        line-height: 20px;
      }
    }
  }

  ::v-deep .btn {
    background: #165dff;
    &:hover {
      background: #4080ff;
    }
  }
  ::v-deep .other-login {
    span {
      color: #165dff;
      &:hover {
        color: #4080ff !important;
      }
    }
  }
}
</style>
